import { render, staticRenderFns } from "./CircularsListSmall.vue?vue&type=template&id=62b2e2d3"
import script from "./CircularsListSmall.vue?vue&type=script&lang=js"
export * from "./CircularsListSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CircularCardSmall: require('/vercel/path0/components/ui/CircularCardSmall.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
